import { useState } from "react";
import { useOutletContext } from "react-router-dom";

import { LayoutPartials, Common } from "@/components";
import { TabAllocation } from "../components";
import { tab } from "@/models";
import {
  PATH,
  SUBSCRIPTION_PRODUCT_TYPE,
} from "@/configuration/globalVariable";

const tabs: tab[] = [
  {
    name: "Import Order",
    current: false,
    subscriptions: [
      SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
      SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
    ],
    children: [
      {
        name: "Upload CSV/Excel file",
        current: false,
        navigation: {
          to: `/${PATH.DELIVERY._}/${PATH.DELIVERY.IMPORT}`,
          type: "NewUI",
          subscriptions: [
            SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
            SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
          ],
        },
      },
      {
        name: "From integration system",
        current: false,
        navigation: {
          to: "/integration/documents/import",
          type: "OldUI",
          subscriptions: [
            SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
            SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
          ],
        },
      },
    ],
  },
  {
    name: "Allocation",
    current: true,
    subscriptions: [
      SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
      SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
    ],
  },
  {
    name: "Route",
    current: false,
    navigation: {
      to: "/delivery/routes",
      type: "OldUI",
      subscriptions: [
        SUBSCRIPTION_PRODUCT_TYPE.TOMBUSINESS,
        SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY,
      ],
    },
  },
];

interface setDateContextType {
  date: Date;
  setDate: (date: Date) => void;
}

const Index = () => {
  const [activeTab, setActiveTab] = useState<any>(tabs[1].name);
  const [date, setDate] = useOutletContext<setDateContextType | any>();

  return (
    <LayoutPartials.BodyContent
      pageTitle="Delivery Management"
      rightContent={
        <Common.TabUnderline
          data={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          wrapClassName="mt-1"
        />
      }
    >
      {activeTab === tabs[1].name && (
        <TabAllocation date={date} setDate={setDate} />
      )}
    </LayoutPartials.BodyContent>
  );
};

export default Index;
